// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2Ss5u","containerItemsCenter":"Skeleton_containerItemsCenter__17smj"};